  import { Icon } from "@iconify/react";
  import classes from "./SearchBox.module.scss";
  import { useState, ChangeEvent } from "react";

  interface SearchBoxProps<T> {
    data: T[];
    onSearch: (filteredData: T[]) => void;
    searchKeys: (keyof T)[];
  }

  function SearchBox<T>({ data, onSearch, searchKeys }: SearchBoxProps<T>) {
    const [searchVal, setSearchVal] = useState<string>("");

    const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.toLowerCase();
      setSearchVal(value);

      if (!value.trim()) {
        onSearch(data);
        return;
      }

      const filtered = data.filter((item) =>
        searchKeys.some((key) => {
          const fieldValue = item[key];
          if (typeof fieldValue === "string") {
            return fieldValue.toLowerCase().includes(value);
          }
          if (typeof fieldValue === "object" && fieldValue !== null) {
            return Object.values(fieldValue)
              .join(" ")
              .toLowerCase()
              .includes(value);
          }
          return false;
        })
      );

      onSearch(filtered);
    };

    return (
      <div className={classes.searchBox}>
        <Icon
          icon="fluent:search-28-filled"
          width="14"
          style={{ fontWeight: "bold" }}
        />
        <input
          type="search"
          placeholder="Search"
          name="search"
          value={searchVal}
          onChange={handleSearch}
          className={classes.searchBox_input}
        />
      </div>
    );
  }

  export default SearchBox;
